import { render, staticRenderFns } from "./EncountersbyDate.vue?vue&type=template&id=84f6ef6a&"
import script from "./EncountersbyDate.vue?vue&type=script&lang=js&"
export * from "./EncountersbyDate.vue?vue&type=script&lang=js&"
import style0 from "./EncountersbyDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports